exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-2dcd60ca] {\r\n  color: black !important;\r\n  border: 1px solid rgba(0, 0, 0, 0.125) !important;\r\n  border-radius: 0.25rem !important;\n}\n.font-15[data-v-2dcd60ca] {\r\n  font-size: 15px;\n}\n.height-queue[data-v-2dcd60ca] {\r\n  /* height: 205px; */\n}\r\n", ""]);

// exports
